import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import * as ViewerService from "../../../../services/ViewerService";
import { useTranslation } from "react-i18next";
import ViewerForm from "./viewerForm.view";
import PATHS from "../../../../constants/paths";
import {
  BreadCrumb,
  ShowAlertDialog,
} from "@de-prado-dev/react-component-library";
import { useDispatch } from "react-redux";
import { hide } from "redux-modal";

const ViewerFormContainer = ({ sessionUuid, refresh }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handlerClosePopup = (popupName) => {
    dispatch(hide(popupName));
  };

  const handleSubmit = async (values, resetForm) => {
    try {
      if (values) {
        let result = undefined;

        result = await ViewerService.addViewer(values, sessionUuid);

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          title = t("forms.viewer.messages.create.title");
          text = t("forms.viewer.messages.create.success");
          icon = "success";
        } else {
          title = "Error";
          text = t("forms.viewer.messages.create.error");
          icon = "error";
        }

        let okAction = () => {
          handlerClosePopup("ModalForm");
          if (refresh) {
            refresh();
          }
        };
        ShowAlertDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      //console.log('Error', error);
    }
  };

  const handleOnback = () => {
    navigate(PATHS.LIST_COURSE);
  };

  return <ViewerForm onSubmit={handleSubmit} onBack={handleOnback} />;
};

ViewerFormContainer.propTypes = {
  sessionUuid: PropTypes.string,
  refresh: PropTypes.func,
};

export default ViewerFormContainer;
